import mainServerClient from "@/services/http/mainServerClient";

export interface SortationCodeRule {
    name: string;
    condition: SortationCodeCondition;
    quantity: number;
}

export enum SortationCodeFormat {
    FORMAT_A = "FORMAT_A",
    FORMAT_B = "FORMAT_B",
    FORMAT_CUSTOM = "FORMAT_CUSTOM",
}

export enum SortationCodeCondition {
    GREATER_THAN = ">",
    EQUAL = "=",
}

export interface SortationCodeSetting {
    companyId: number;
    lastUpdated: string;
    /** 分拣码规则 */
    rules: SortationCodeRule[];
    format: SortationCodeFormat;
    /** 格式模板内容 */
    templateContent?: string;
}

export function saveSortationCodeSetting(
    setting: Omit<SortationCodeSetting, "lastUpdated">,
): Promise<SortationCodeSetting> {
    return mainServerClient.post("/sortation_code_setting/save", setting);
}

export function getSortationCodeSetting(): Promise<SortationCodeSetting> {
    return mainServerClient.get("/sortation_code_setting/get");
}
